import axios from 'axios';
import { BASE_URL } from './CommonExport';
import { getBearerToken, storeSessionToken } from '../utils/authToken';

const fetchData = async () => {
  try {
    const bearer = getBearerToken();
    const response = await axios.post(
      `${BASE_URL}/admin/authenticate`,
      {},
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          ...(bearer ? { Authorization: bearer } : {}),
        },
      }
    );

    if (response?.data?.statusCode == 10000) {
      storeSessionToken(response?.data?.data?.token);
      return response;
    }

    return false;
  } catch (error) {
    console.error('Error fetching data:', error);
    // No alert/redirect here — the caller (App.js) already handles the
    // not-authenticated case for both this rejection path and the
    // statusCode !== 10000 path above. Doing it here too meant a single
    // failed check fired two stacked alert() dialogs.
    return false;
  }
};

export default fetchData;
